interface CardProps {
  children: React.ReactNode
  className?: string
  [key: string]: any
}

interface CardContentProps {
  children: React.ReactNode
  className?: string
  [key: string]: any
}

export const Card = ({ children, className = '', ...props }: CardProps) => (
  <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`} {...props}>
    {children}
  </div>
)

export const CardContent = ({ children, className = '', ...props }: CardContentProps) => (
  <div className={`p-6 ${className}`} {...props}>
    {children}
  </div>
)
